<template>
    <span :data-balloon="tooltip" data-balloon-pos="up">
        <button class="copy simple" @click="open"><i class="fa fa-copy"></i></button>
        <div class="remodal" :data-remodal-id="modalID">
            <p>Are you sure you want to copy <strong>{{title}}</strong>?</p>
            <button data-remodal-action="cancel" class="remodal-cancel simple">Cancel</button>
            <button data-remodal-action="confirm" class="remodal-confirm simple" @click="confirm">OK</button>
        </div>
    </span>
</template>

<script>
    import Modal from 'vue/common/_modal';
    import {mapActions} from 'vuex'

    export default {
        computed: {
            modalID() {
                return `${this.id}-copy`
            },
            item() {
                return {
                    id: this.id,
                    url: this.url
                }
            }
        },

        methods: {
            confirm() {
                this.copyItem(this.item)
                .then(() => {
                    //Temporary before we change this template into a vue template
                    if (window.location.pathname === '/submittal-manager') {
                        window.location.reload();
                    }
                });
            },
            ...mapActions('mechanical', [
                'copyItem'
            ])
        },
        extends: Modal,
        props: {
            id: {
                type: String
            },
            title: {
                type: String
            },
            url: {
                type: String
            },
            tooltip: {
                default: "Copy Project",
                type: String
            }
        }
    }
</script>